/* Author: Andrés Aguilar Email: andresyoshimar@gmail.com Date: 14/06/2019
Modified: 04/12/2019 version: 0.0.2 */
<template>
  <form @submit.prevent="submitData" id="profile-form" v-if="updatedAccount.userId">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <img-with-fallback :src="updatedAccount.avatar" alt="User profile picture" />
        </div>
        <h3 class="title">{{ updatedAccount.username }}</h3>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <p class="title title-large">Información personal</p>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-25">
            <md-field>
              <label for="movie">Título</label>
              <md-select v-model="updatedAccount.treatment" name="treatment" id="treatment">
                <md-option v-for="(treat, i) in treatments" :key="i" :value="treat">{{ treat }}</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-75"></div>

          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Nombre(s):</label>
              <md-input v-model="updatedAccount.firstName" type="text"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Apellido paterno:</label>
              <md-input v-model="updatedAccount.lastName" type="text"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Apellido materno:</label>
              <md-input v-model="updatedAccount.secondLastName" type="text"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <p class="title title-large">Contacto</p>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Email:</label>
              <md-input type="email" v-model="updatedAccount.email"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Email alternativo:</label>
              <md-input type="email" v-model="updatedAccount.alternativeEmail"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Teléfono:</label>
              <md-input type="phone" v-model="updatedAccount.phone"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Extensión:</label>
              <md-input type="number" v-model="updatedAccount.phoneExt"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Cellphone:</label>
              <md-input type="phone" v-model="updatedAccount.cellphone"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <p class="title title-large">Dirección</p>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Calle:</label>
              <md-input type="text" v-model="updatedAccount.address.street"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Colonia:</label>
              <md-input type="text" v-model="updatedAccount.address.colony"></md-input>
            </md-field>
          </div>

          <div
            v-if="updatedAccount.address.state"
            class="md-layout-item md-small-size-100 md-size-33"
          >
            <md-field>
              <label for="movie">Estado:</label>
              <md-select
                v-model="updatedAccount.address.state.id"
                name="state"
                id="state"
                @md-closed="getMunicipality()"
              >
                <md-option
                  v-for="state in states"
                  :key="state.id"
                  :value="state.id"
                >{{ state.name }}</md-option>
              </md-select>
            </md-field>
          </div>

          <div
            v-if="updatedAccount.address.municipality"
            class="md-layout-item md-small-size-100 md-size-25"
          >
            <md-field>
              <label for="movie">Municipio:</label>
              <md-select
                v-model="updatedAccount.address.municipality.id"
                name="municipality"
                id="municipality"
              >
                <md-option
                  v-for="municipality in municipalities"
                  :key="municipality.id"
                  :value="municipality.id"
                >{{ municipality.name }}</md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-25">
            <md-field>
              <label>C.P.</label>
              <md-input type="text" v-model="updatedAccount.address.postal_code"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-25">
            <md-field>
              <label>Número:</label>
              <md-input type="text" v-model="updatedAccount.address.no_ext"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-25">
            <md-field>
              <label>Númerointerior:</label>
              <md-input type="text" v-model="updatedAccount.address.no_int"></md-input>
            </md-field>
          </div>
        </div>

        <div class="md-layout">
          <image-field :editedObject="updatedAccount" :useBase64="true" fieldName="avatar"></image-field>
        </div>
      </md-card-content>

      <md-card-actions md-alignment="right">
        <md-button class="md-success" type="submit" form="profile-form">Guardar</md-button>
      </md-card-actions>
    </md-card>
  </form>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import { ImageField } from "@/components";
import accountService from "@/services/account";

export default {
  name: "EditUserProfile",
  components: { ImageField },
  data() {
    return {
      updatedAccount: {
        userId: null,
        username: null,
        treatment: null,
        firstName: null,
        lastName: null,
        secondLastName: null,
        email: null,
        // Profile information
        profileId: null,
        avatar: null,
        phone: null,
        phoneExt: null,
        cellphone: null,
        alternativeEmail: null,
        // Groups and permissions
        userArea: null,
        userRole: null,
        userRoleCode: null,
        userType: null,
        address: {},
      },
      treatments: ["C.", "Lic.", "Ing.", "Mtro.", "Doc."],
      states: [],
      municipalities: {},
    };
  },
  computed: {
    ...mapState(["account"]),
  },
  methods: {
    getMunicipality() {
      if (!this.updatedAccount.address.state) {
        return;
      }
      const state = this.updatedAccount.address.state.id;

      Vue.$http
        .get(`catalogs/common/states/${state}/`)
        .then((response) => (this.municipalities = response.data.Municipality));
    },
    submitData() {
      accountService
        .update(this.updatedAccount)
        .then(() => {
          this.$successMessage({ title: "Perfil actualizado" });
          this.$router.push({ name: "Perfil de usuario" });
        })
        .catch(this.$fireErrorResponse);
    },
  },
  watch: {
    account: {
      immediate: true,
      deep: true,
      handler() {
        const account = JSON.parse(JSON.stringify(this.account));

        if (!account) {
          return;
        }
        const address = account.address;
        const updatedAccount = { ...account, address: { ...address } };
        this.updatedAccount = updatedAccount;
        // Request States and municipalities
        if (!this.updatedAccount.address.state) {
          return;
        }
        Vue.$http.get("catalogs/common/states/").then((response) => {
          this.states = response.data;
        });
        Vue.$http
          .get(
            `catalogs/common/states/${this.updatedAccount.address.state.id}/`
          )
          .then(
            (response) => (this.municipalities = response.data.Municipality)
          );
      },
    },
  },
};
</script>

<style lang="css" scoped>
img {
  max-width: 60px;
}
span {
  color: #606060;
}
.title-large {
  font-size: 1.5em;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/UserProfileComponents/EditProfile.vue